import React, { useState, useEffect } from 'react';

interface CRMONCELogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'full' | 'icon' | 'text';
  className?: string;
}

const CRMONCELogo: React.FC<CRMONCELogoProps> = ({ 
  size = 'md', 
  variant = 'full',
  className = '' 
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const sizeClasses = {
    sm: {
      icon: 'w-12 h-12', // Reduced for better header fit
      text: 'text-lg',
      full: 'text-sm',
      tagline: 'text-xs'
    },
    md: {
      icon: 'w-16 h-16', // Reduced for better header fit
      text: 'text-2xl',
      full: 'text-lg',
      tagline: 'text-sm'
    },
    lg: {
      icon: 'w-20 h-20', // Reduced for better header fit
      text: 'text-3xl',
      full: 'text-xl',
      tagline: 'text-base'
    },
    xl: {
      icon: 'w-24 h-24', // Extra large for header
      text: 'text-4xl',
      full: 'text-2xl',
      tagline: 'text-lg'
    }
  };

  const LogoIcon = () => (
    <div className={`${sizeClasses[size].icon} relative flex items-center justify-center ${className}`}>
      {!imageError ? (
        <img 
          src="/logo.png" 
          alt="CRMONCE Logo" 
          className="w-full h-full object-contain"
          onLoad={() => {
            console.log('✅ CRMONCE Logo loaded successfully');
            setImageLoaded(true);
          }}
          onError={() => {
            console.warn('❌ CRMONCE Logo image failed to load, using fallback');
            setImageError(true);
          }}
        />
      ) : (
        <div className="w-full h-full bg-blue-600 rounded-lg flex items-center justify-center">
          <span className="text-white font-bold text-sm">CRMONCE</span>
        </div>
      )}
    </div>
  );

  const LogoText = () => (
    <div className={`font-bold ${sizeClasses[size].text} ${className}`}>
      <span className="text-blue-600">
        CRM<span className="text-gray-800 font-normal">|</span>ONCE
      </span>
    </div>
  );

  const LogoFull = () => (
    <div className={`flex items-center ${className}`}>
      <LogoIcon />
    </div>
  );

  // Debug logging
  useEffect(() => {
    console.log('🔍 CRMONCELogo component mounted with:', {
      size,
      variant,
      logoSources: '/logo.png' // Updated to reflect new source
    });
  }, [size, variant]);

  switch (variant) {
    case 'icon':
      return <LogoIcon />;
    case 'text':
      return <LogoText />;
    case 'full':
    default:
      return <LogoFull />;
  }
};

export default CRMONCELogo; 